import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { useLoggedUser } from '../services/user';

export default function useAuth() {
  const { data, isLoading } = useLoggedUser();

  useEffect(() => {
    if (data) {
      Sentry.getGlobalScope().setUser({
        id: data.id,
        email: data.email,
        username: data.email,
        'First Name': data.firstName,
        'Last Name': data.lastName,
      });
    } else {
      Sentry.getGlobalScope().setUser(null);
    }
  }, [data]);

  return {
    loggedIn: !!data,
    loading: isLoading,
    user: data,
  };
}
